import { IVendorUser } from "@smartrr/shared/entities/VendorUser";
import config from "@vendor-app/config";
import { loadIntercom } from "../scripts/loadIntercom";
import { useEffect } from "react";
import { useSmartrrFlags } from "@smartrr/shared/LaunchDarkly";
import { loadZendeskChat } from "@vendor-app/scripts/loadZendeskChat";
import { useLDClient } from "launchdarkly-react-client-sdk";

function appendIntercom(authUser: IVendorUser): void {
  const appId = config.intercom.appId;

  if (!appId) {
    loadZendeskChat();
    return;
  }

  loadIntercom(appId);

  if (typeof window.Intercom !== "function") {
    return;
  }

  window.Intercom("boot", {
    api_base: "https://api-iam.intercom.io",
    app_id: appId,
    user_id: authUser.id,
    user_hash: authUser.intercomHash,
    email: authUser.originalEmail,
    name: [authUser.originalFirstName, authUser.originalLastName].filter(Boolean).join(" "),
    created_at: Math.floor(new Date(authUser.createdDate).getTime() / 1000),
    source_app: "Smartrr",
    messenger_style_id: "2928378", // Smartrr Messenger Style
  });
}

export function InitIntercom(user: IVendorUser | null): void {
  const { vendorPortalIntercom } = useSmartrrFlags();
  const ldClient = useLDClient();

  useEffect(() => {
    if (!user || user.isSuperUser || !ldClient) {
      return;
    }

    // TODO: Remove this once Intercom is fully migrated
    if (!vendorPortalIntercom) {
      loadZendeskChat();
      return;
    }

    appendIntercom(user);
  }, [vendorPortalIntercom, user, ldClient]);
}
